import BaseModel from "./BaseModel";
import moment from "moment";
import Document from "./Document";

export default class Customer extends BaseModel {

	static entity = 'customers';
	static route = 'customers';
	static plural = 'customers';
	static singular = 'customer';

	static fields () {
		return {
			id: this.attr(null),
			name: this.attr(null),
			website: this.attr(null),
			email: this.attr(null),
			phone: this.attr(null),
			builder: this.attr(null),
			dealer: this.attr(null),
			rate: this.attr(null),
			description: this.attr(null),
			signature: this.attr(null),
			product_type_access: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),

			logo_id: this.attr(null),
			logo: this.belongsTo(Document, 'logo_id'),
		}
	}

	static missingFields(entity) {
		let missing = [];
		let required = ['name', 'email', 'phone'];
		if(!entity || !entity.id) {
			return missing;
		} else {
			required.forEach((field) => {
				if(!entity[field] || entity[field] === '') {
					missing.push(field);
				}
			});
		}
		return missing;
	}

	static isExpired(entity) {
		if(!entity || !entity.id) {
			return false;
		} else if(entity.updated_at) {
			return moment(entity.updated_at).diff(moment(), 'months') >= 6;
		} else if(entity.created_at) {
			return moment(entity.created_at).diff(moment(), 'months') >= 6;
		}
		return true;
	}

	static configureApi() {
		let config = super.configureApi();
		config.actions.saveSignature = function(document_id) {
			return this.post('/'+Customer.route+'/signature/'+document_id, {}, {
				dataTransformer: (response) => {
					return Customer.transformDefault(response, 'customer');
				}
			});
		};
		//:: STRIPE METHODS
		config.actions.getPaymentMethods = function(customer_id) {
			return this.get('/'+Customer.route+'/'+customer_id+'/payment-methods', {dataTransformer: () => []});
		};
		config.actions.createPaymentIntent = function(customer_id, payload) {
			return this.post('/'+Customer.route+'/'+customer_id+'/payment-intents', payload, {dataTransformer: () => []});
		};
		config.actions.storePaymentMethod = function(customer_id, payload) {
			return this.post('/'+Customer.route+'/'+customer_id+'/payment-methods', payload, {dataTransformer: () => []});
		};
		config.actions.charge = function(customer_id, payload) {
			let r = this.post('/'+Customer.route+'/'+customer_id+'/charge', payload, {dataTransformer: () => {return[];}, responseType: 'arraybuffer'});
			console.log(r);
			return r;
		};
		return config;
	}

	static apiConfig = this.configureApi();

}
